<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="2" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;"
					src="../../../assets/img/wofangxinxi-icon.png" />
				账户列表
			</el-col>
			<el-col :xs="24" :md="3" style="
				line-height: 40px;
				font-size: 16px;
				color: #121212;
				font-weight: bold;
				">
				<el-select style="width: 95%" v-model="dataForm.userType" placeholder="用户类型" @change="getvalue"
				filterable>
				<el-option v-for="item in jiesuan" :key="item.value" :label="item.label" :value="item.value"
					:disabled="item.disabled"></el-option>
				</el-select>
			</el-col>
			<el-col :xs="24" :md="13" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;text-align:right;">
				服务费总额：{{payfee}}
				<!--<el-button type="primary" @click="listHandle()">详情</el-button>-->
				<!-- <el-button type="primary"
						   style="margin-left: 10px"
						v-if="infodata.showPayPassBtn && $hasPermission('plat:plattransactiondetais:setPaymentPassword') && infodata.hasSetPayPass==false"
						@click="setpwd(0)">设置支付密码</el-button>
				<el-button type="primary"
						   style="margin-left: 10px"
					v-if="infodata.showPayPassBtn && $hasPermission('plat:plattransactiondetais:setPaymentPassword') && infodata.hasSetPayPass==true"
					@click="setpwd(1)">修改支付密码</el-button> -->
			</el-col>
			<el-col :xs="24" :md="6">
				<el-form :inline="true" style="text-align: right;" :model="dataForm"
					@keyup.enter.native="getDataList()">
					<el-form-item>
						<el-button v-if="$hasPermission('plat:plataccount:export')" type="primary"
							@click="exportHandle()">{{ $t('export') }}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="info" @click="getDataList()">刷新</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<div class="mod-plat__plattransactiondetais">
			<el-form :inline="true" label-width="100px" ref="dataForm"
				style="padding-top: 10px;padding-left:10px;text-align: left;" :model="dataForm"
				@keyup.enter.native="getDataList()">
				<el-form-item label="我方主体名称:" prop="subjectName">
					<el-select v-model="dataForm.subjectName" placeholder="我方主体名称" clearable @change="subjectNameChange" filterable>
						<el-option v-for="platBody in platBodyList" :key="platBody.id" :label="platBody.bodyName"
							:value="platBody.bodyName"></el-option>
					</el-select>
				</el-form-item>

				<!-- <el-form-item label="用户类型:" prop="userType">
					<ren-select v-model="dataForm.userType" dict-type="userType" placeholder="用户类型" disabled >
					</ren-select>
				</el-form-item> -->
				<el-form-item label="用户名称:" prop="name">
					<el-input v-model="dataForm.name" placeholder="用户名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getDataList()">执行查询</el-button>
					<el-button class="refreshBtn" type="info" @click="resetForm('dataForm')">重置</el-button>
				</el-form-item>

			</el-form>
			<div class="table-container">
				<el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle"
					style="width: 100%;" height="100%">
					<el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
					<el-table-column label="序号" type="index" width="50" align="center">
						<template slot-scope="scope">
							<span>{{ (page - 1) * limit + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="userType" label="用户类型" header-align="center" align="center">
						<template slot-scope="scope">
							{{ $getDictLabel("userType", scope.row.userType) }}
						</template>
					</el-table-column> -->
					<el-table-column prop="name" label="用户名称" header-align="center" align="center"></el-table-column>
					<el-table-column prop="bank" label="开户行" header-align="center" align="center"></el-table-column>
					<el-table-column prop="bankAccount" label="银行账户" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bankName" label="支付方式" header-align="center" align="center"></el-table-column>
					<el-table-column prop="bodyName" label="我方主体" header-align="center" align="center"></el-table-column>
					<!-- <el-table-column prop="authrCd" label="浦发授权码" header-align="center" align="center"></el-table-column> -->
					<el-table-column prop="childAcctNo" label="子账号" header-align="center" align="center" v-if="dataForm.userType == 'qyyh'"></el-table-column>
					<el-table-column prop="balance" label="账户余额" header-align="center" align="center" v-if="dataForm.userType == 'qyyh'"></el-table-column>
					<el-table-column prop="totalChargeAmount" label="累计充值（收款）金额" header-align="center" align="center"></el-table-column>
					<el-table-column prop="isEnable" :label="$t('user.status')" header-align="center" align="center">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.status == 0" size="small" type="danger">{{ $t('user.status0') }}
							</el-tag>
							<el-tag v-else size="small" type="success">{{ $t('user.status1') }}</el-tag>
						</template>
					</el-table-column>
					<!-- </el-table-column> -->

					<!-- <el-table-column v-if="$hasPermission('plat:plataccount:update')" :label="$t('handle')" fixed="right"
						header-align="center" align="center" width="200">
						<template slot-scope="scope">
							<el-button v-if="scope.row.status == 0 &&scope.row.userType!='gryh' " type="text" size="small"
								@click="enableOrDisableHandle(scope.row.spdAccountId,1)">
								启用
							</el-button>
							<el-button v-if="scope.row.status == 1 && scope.row.userType!='gryh'" type="text" size="small"
								@click="enableOrDisableHandle(scope.row.spdAccountId,0)">
								停用
							</el-button> -->
							<!--<el-button v-if="scope.row.userType!='gryh'" type="text" size="small"-->
								<!--@click="chongzhiHandle(scope.row.id,scope.row.name)">-->
								<!--充值-->
							<!--</el-button>-->
							<!--<el-button v-if="scope.row.userType!='gryh'" type="text" size="small"-->
								<!--@click="refundHandle(scope.row.spdAccountId)">-->
								<!--退款-->
							<!--</el-button>-->
							<!-- <el-button v-if="scope.row.userType=='gryh'" type="text" size="small"
								@click="withdrawalHandle(scope.row.spdAccountId)">
								提现
							</el-button> -->
						<!-- </template>
					</el-table-column> -->
				</el-table>
				<el-pagination background :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit"
					:total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
					@current-change="pageCurrentChangeHandle"></el-pagination>
			</div>
			<!-- 弹窗, 新增 / 修改 -->
			<set-chongzhi v-if="setczVisible" ref="setchongzhi" @refreshDataList="getDataList"></set-chongzhi>
			<refund v-if="refundVisible" ref="refund" @refreshDataList="getDataList"></refund>
			<set-pwd v-if="setpwdVisible" ref="SetPwd" @refreshDataList="getdefaultInfo"></set-pwd>
			<withdrawal v-if="withdrawalVisible" ref="withdrawal" @refreshDataList="getDataList"></withdrawal>
			<list v-if="listVisible" ref="list" @refreshDataList="getDataList"></list>
			<details v-if="detailsVisible" ref="details" @refreshDataList="getDataList"></details>
		</div>
	</el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './plattransactiondetais-add-or-update'
import SetPwd from './plattransactiondetais-set-pwd'
import uploadBtn from '../uploadBtn'
import SetChongzhi from './plattransactiondetais-set-chongzhi'
import Refund from './plataccount-refund.vue'
import Withdrawal from './plataccount-withdrawal'
import List from './plataccount-payfee-list'
import Details from './plataccount-payfee-details'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
		jiesuan: [
          {
            value: "qyyh",
            label: "企业用户",
          },
          {
            value: "gryh",
            label: "个人用户",
          },
        ],
	  setpwdVisible: false,
      setczVisible: false,
      withdrawalVisible: false,
      listVisible: false,
      detailsVisible: false,
      refundVisible: false,
      mixinViewModuleOptions: {
        getDataListURL: '/sys/account/page',
        getDataListIsPage: true,
        exportURL: '/sys/account/export'
      },
      platBodyList: [],
      dataForm: {
        subjectName: '',
		bodyId:'',
        userType: 'qyyh',
        name: ''
	  },
	  infodata: [],
	  payfee : 0,
    }
  },
  components: {
    AddOrUpdate,
    uploadBtn,
    SetChongzhi,
	Refund,
	SetPwd,
    Withdrawal,
    List,
    Details
  },
  watch:{
	  
	  dataForm:{
		handler(val, oldVal){
			if(val.userType == 'gryh'){
			this.dataForm.subjectName = '';
			this.dataForm.bodyId = '';  
		  }
        },
         deep:true //true 深度监听
	  }
  },
  methods: {
	getvalue(e){
		this.$refs.dataForm.resetFields()
		this.dataForm.bodyId='';
        this.dataForm.userType = e;

		this.getDataList();
	},
    // 获取数据填充数据
    updateByTimeSlot () {
      this.dataForm.startDate = this.GetDateStr(this.dataForm.timeSlot)
      this.dataForm.endDate = this.getdataTime()
    },
    // 获取当前日期时间
    getdataTime () {
      var now = new Date()
      var year = now.getFullYear() // 得到年份
      var month = now.getMonth() // 得到月份
      var date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')

      var defaultDate = `${year}-${month}-${date}`
      return defaultDate
    },
    // 上传成功
    backSuccess (datas) {
      this.query()
    },
    GetDateStr (days) {
      var AddDayCount = parseInt(days)
      var dd = new Date()
      dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1 // 获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate() // 获取当前几号，不足10补0
      return y + '-' + m + '-' + d
    },
    // 获取我方主体列表
    getPlatBodyList () {
      this.$http
        .get('/sys/plat/body/list')
        .then(({
          data: res
        }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.platBodyList = res.data
        })
        .catch(() => {})
    },
	setpwd (type) {
      this.setpwdVisible = true
      this.$nextTick(() => {
        this.$refs.SetPwd.init()
        this.$refs.SetPwd.type = type
      })
	},
	getdefaultInfo () {
      this.$http
        .get('/sys/account/page-data')
        .then(({
          data: res
        }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.infodata = res.data
          console.log(this.infodata)
        })
        .catch(() => {})
    },
    // 获取服务费总额
    getPlatBodySum () {
      this.$http
        .get('/sys/plat/body/sum')
        .then(({
          data: res
        }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.payfee = res.data
        })
        .catch(() => {})
    },
    // 充值
    chongzhiHandle (id, name) {
      this.setczVisible = true
      this.$nextTick(() => {
        this.$refs.setchongzhi.init()
        this.$refs.setchongzhi.dataForm.userId = id
        this.$refs.setchongzhi.dataForm.payerName = name
      })
    },
    // 退款
    refundHandle (id) {
      this.refundVisible = true
      this.$nextTick(() => {
        this.$refs.refund.dataForm.id = id
        this.$refs.refund.init()
        /* this.$refs.refund.init()
					this.$refs.refund.dataForm.userId = id
					this.$refs.refund.dataForm.payerName = name */
      })
    },
    // 提现
    withdrawalHandle (id) {
      this.withdrawalVisible = true
      this.$nextTick(() => {
        this.$refs.withdrawal.dataForm.id = id
        this.$refs.withdrawal.init()
        /* this.$refs.withdrawal.init()
					this.$refs.withdrawal.dataForm.userId = id
					this.$refs.withdrawal.dataForm.payerName = name */
      })
    },
    // 余额
    listHandle () {
      this.listVisible = true
      this.$nextTick(() => {
        this.$refs.list.init()
      })
    },
    // 详情
    detailsHandle () {
      this.detailsVisible = true
      this.$nextTick(() => {
        this.$refs.details.init()
      })
    },
    resetForm (formName) {
	  this.$refs[formName].resetFields()
	  this.dataForm.bodyId='';
	  this.getDataList();
    },
    enableOrDisableHandle (id, isEnable) {
			  this.$confirm('此操作将' + (isEnable === 0 ? '将禁用' : '将启用') + '此条帐号, 是否继续?', '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			    this.handle(id, isEnable)
			  }).catch(() => {
			    this.$message({
			      type: 'info',
			      message: '已取消操作'
			    })
			  })
    },
    handle (id, isEnable) {
			  this.$http.get('/sys/spdb/enableOrDisable', {
			    params: {
			      id: id,
			      status: isEnable
			    }
			  }).then(({ data: res }) => {
			    if (res.code !== 0) {
			      return this.$message.error(res.msg)
			    } else {
			      this.$message({
			        message: this.$t('prompt.success'),
			        type: 'success',
			        duration: 500,
			        onClose: () => {
			          this.query()
			        }
			      })
			    }
			  }).catch(() => {})
    },
	subjectNameChange(value){
		this.dataForm.bodyId=""
		this.dataForm.bodyId = this.platBodyList.filter(item=>{
			return item.bodyName == value
		})[0].id
	},
  },
  created () {
    this.getPlatBodyList()
	this.getPlatBodySum()
	this.getdefaultInfo()
  }
}
</script>

<style>
.mod-plat__plattransactiondetais {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 190px);

  .el-form {
    flex-shrink: 0;
  }

  .table-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 10px;

    .el-table {
      flex: 1;
      overflow: auto;
    }

    .el-pagination {
      flex-shrink: 0;
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>